import modular from 'modujs';
import * as modules from './modules';
import globals from './globals';
import { debounce } from './utils/tickers'
import { $html } from './utils/dom';
import { ENV, FONT, CUSTOM_EVENT, CSS_CLASS } from './config'
import { isFontLoadingAPIAvailable, loadFonts } from './utils/fonts';
import {$screen} from "./stores/screen.js";
import Mouse from "./classes/Mouse.js";
import Cursor from "./classes/Cursor.js";
import {isTouchDevice} from "./utils/is.js";

const app = new modular({
    modules: modules,
});

const setViewportSizes = () => {

    // Document styles
    const documentStyles = document.documentElement.style;    

    // Viewport width
    const vw = document.body.clientWidth * 0.01;
    documentStyles.setProperty('--vw', `${vw}px`);

    // Return if browser supports vh, svh, dvh, & lvh
    if (ENV.SUPPORTS_VH) {
        return
    }

    // Viewport height
    const height = window.innerHeight;
    const svh = document.documentElement.clientHeight * 0.01;
    documentStyles.setProperty('--svh', `${svh}px`);
    const dvh = height * 0.01;
    documentStyles.setProperty('--dvh', `${dvh}px`);

    if (document.body) {
        const fixed = document.createElement('div');
        fixed.style.width = '1px';
        fixed.style.height = '100vh';
        fixed.style.position = 'fixed';
        fixed.style.left = '0';
        fixed.style.top = '0';
        fixed.style.bottom = '0';
        fixed.style.visibility = 'hidden';

        document.body.appendChild(fixed);

        const fixedHeight = fixed.clientHeight;

        fixed.remove();

        const lvh = fixedHeight * 0.01;

        documentStyles.setProperty('--lvh', `${lvh}px`);
    }
}

window.addEventListener('load', () => {
    init();
});

function init() {
    globals();
    setViewportSizes();

    app.init(app);

    $html.classList.toggle('is-firefox', navigator.userAgent.indexOf("Firefox") != -1);

    $html.classList.toggle('is-touch-device', isTouchDevice());

    setTimeout(() => {
        $html.classList.add(CSS_CLASS.HAS_JS);
        $html.classList.remove(CSS_CLASS.HAS_NO_JS);
    
        $html.classList.add(CSS_CLASS.LOADED);
        $html.classList.remove(CSS_CLASS.LOADING);
        
        setTimeout(() => {        
            $html.classList.add(CSS_CLASS.READY);
        }, $html.dataset.template == 'front-page.php' ? 600 : 0)
    }, $html.dataset.template == 'template-explore.php' ? 300 : 100)
    
    // Bind window resize event with default vars
    const resizeEndEvent = new CustomEvent(CUSTOM_EVENT.RESIZE_END)

    const onResize = () => {
        window.dispatchEvent(resizeEndEvent)
    }

    $screen.subscribe(setViewportSizes)

    $screen.subscribe(
        debounce(
            onResize,
            200,
            false
        )
    )
    window.addEventListener('orientationchange', () => {
        setViewportSizes();
    })

    /**
     * Eagerly load the following fonts.
     */
    if (isFontLoadingAPIAvailable) {
        loadFonts(FONT.EAGER, false/*ENV.IS_DEV*/).then((eagerFonts) => {
            $html.classList.add(CSS_CLASS.FONTS_LOADED);

            /*
            if (ENV.IS_DEV) {
                console.group('Eager fonts loaded!', eagerFonts.length, '/', document.fonts.size);
                console.group('State of eager fonts:')
                eagerFonts.forEach((font) => console.log(font.family, font.style, font.weight, font.status))
                console.groupEnd()
                console.group('State of all fonts:')
                document.fonts.forEach((font) => console.log(font.family, font.style, font.weight, font.status))
                console.groupEnd()
            }
            */
        });
    }

    /*
    * Mouse + Cursor
    */
    if (!isTouchDevice()) {
        new Mouse()
        new Cursor()
    }
 
    document.getElementById('admin-bar-inline-css')?.remove?.(); 
}
